import React, { useEffect, useState } from 'react';
import FormGroup from '@mui/material/FormGroup';
import BoxRadioComponent from './BoxRadioComponent';
import { v4 as uuidv4 } from 'uuid';

const TypeSelector = ({ sendSelectedColor, radioParams, module, option }) => {
  const isModuleMilieu = module === 'milieu' ? '_' + option : '';
  const [value, setValue] = useState(
    JSON.parse(
      window.sessionStorage.getItem(module + '_type' + isModuleMilieu)!
    ) || radioParams[0].value
  );
  const [boxChecked, setBoxChecked] = useState<any>({});

  // update checkbox selected
  const initRadioChecked = () => {
    // init target to test
    let target;
    if (typeof value === 'string') {
      target = value;
    } else {
      target = value.code;
    }

    // find params of box checked
    const box = radioParams.find((radio) => radio.value === target);

    // create object to update boxes
    let object = {};
    radioParams.forEach((radio) => {
      object[radio.boxId] = false;
    });

    // set box checked
    setBoxChecked({
      ...object,
      [box.boxId]: true,
    });
  };

  const handleChange = (event: any, opt: any) => {
    // trigger initRadioChecked to update radio
    setValue(event.target.value);
    // find params of box checked to update map
    const box = radioParams.find((radio) => radio.value === event.target.value);
    sendSelectedColor(null, { name: box.label, code: box.value });
  };

  // component did mount
  useEffect(() => {
    initRadioChecked();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    initRadioChecked();
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  const styleBoxCss = {
    display: 'inline-flex',
    padding: '4px',
    fontSize: '15px',
    textAlign: 'center',
    width: 'auto',
    gap: '5px',
    fontWeight: 'bold',
    alignItems: 'center',
  };

  return (
    <FormGroup id='radio-check' row style={{}}>
      {radioParams.map((radio: any) => {
        return (
          <div key={uuidv4()}>
            <BoxRadioComponent
              id={radio.boxId}
              label={radio.label}
              styleBox={styleBoxCss}
              name={radio.name}
              value={radio.value}
              onChange={handleChange}
              defaultChecked={boxChecked[radio.boxId]}
              type={'radio'}
            />
          </div>
        );
      })}
    </FormGroup>
  );
};
export default TypeSelector;
